import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=7272f260&scoped=true&"
import script from "./PublishButton.vue?vue&type=script&lang=js&"
export * from "./PublishButton.vue?vue&type=script&lang=js&"
import style0 from "./PublishButton.vue?vue&type=style&index=0&id=7272f260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7272f260",
  null
  
)

export default component.exports